import { Navigate } from 'react-router-dom'
import useWhatsappAccess from 'hooks/useWhatsappAccess'

/* A tela da Gestão WhatsApp só abre para salão liberado; os outros voltam para a agenda. */
export default function WhatsappRoute({ children }) {
  const access = useWhatsappAccess()
  if (access === undefined) return null
  return access ? children : <Navigate to='/business' replace/>
}
